<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="85" height="36"
         viewBox="0 0 85 36" style="enable-background:new 0 0 85 36;" xml:space="preserve">

        <path :class="secondaryColor" d="M45.7,19.6h0.5c0.4,0,0.9,0,1.3,0.1c0.3,0.1,0.6,0.3,0.8,0.5c0.5,0.6,1,1.2,1.4,1.9l1.9,2.8h3.1l-1.6-2.5
	c-0.4-0.7-0.9-1.4-1.5-2.1c-0.4-0.4-0.9-0.8-1.4-1.1c1-0.1,1.9-0.5,2.5-1.2c0.6-0.7,0.9-1.5,0.9-2.4c0-0.7-0.2-1.4-0.6-2
	c-0.3-0.6-0.9-1-1.5-1.2c-1-0.3-2-0.4-3-0.3h-5.5V25h2.6V19.6z M45.7,14.3h2c1.1,0,1.7,0,1.9,0c0.4,0,0.7,0.2,1,0.5
	c0.2,0.3,0.4,0.7,0.3,1c0,0.3-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.4-0.7,0.5c-0.8,0.1-1.6,0.2-2.3,0.2h-1.9L45.7,14.3z M20.6,23.5
	c1.1,1.2,2.6,1.8,4.2,1.8c1.2,0.1,2.4-0.3,3.4-1c1-0.8,1.7-1.9,1.9-3.1l-2.5-0.8c-0.1,0.8-0.5,1.5-1.1,2.1c-0.5,0.4-1.1,0.7-1.8,0.7
	c-0.9,0-1.7-0.4-2.3-1c-0.7-1-1-2.3-0.9-3.5c-0.1-1.2,0.2-2.4,0.9-3.3c0.6-0.7,1.4-1.1,2.3-1c0.6,0,1.3,0.2,1.8,0.6
	c0.5,0.4,0.8,1,1,1.6l2.6-0.6c-0.2-0.9-0.7-1.7-1.3-2.4c-1-1-2.4-1.5-3.8-1.4c-1.6-0.1-3.2,0.6-4.4,1.8c-1.2,1.4-1.8,3.2-1.7,5
	C18.8,20.4,19.4,22.1,20.6,23.5z M17,22.8H9.8v-3.5h6.5v-2.2H9.8v-2.9h7v-2.2H7.2V25H17V22.8z M66.1,22.8h-7.2v-3.5h6.5v-2.2h-6.5
	v-2.9h7v-2.2h-9.6V25h9.8V22.8z M71.1,20.1h1.7c0.9,0,1.8,0,2.7-0.2c0.5-0.1,0.9-0.3,1.3-0.6c0.5-0.3,0.8-0.8,1.1-1.3
	c0.3-0.6,0.5-1.3,0.4-2c0-0.9-0.2-1.8-0.7-2.5c-0.5-0.6-1.1-1.1-1.9-1.3c-1-0.2-2.1-0.2-3.1-0.2h-4.2V25h2.6V20.1z M71.1,14.3l1.3,0
	c0.6,0,1.3,0,1.9,0.1c0.4,0.1,0.8,0.3,1,0.6c0.3,0.3,0.4,0.7,0.4,1.2c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.6
	c-0.7,0.2-1.4,0.2-2.1,0.2h-1.4V14.3z M37,6H0v24h37h48V6H37z M36,29H1V7h35V29z M84,29H37V7h47V29z"/>
</svg>

</template>

<script>

export default {
    name: "authorizedRepresentativeIcon",
    computed :{
        // When using high contrast on white/black background we need the svg to be black/white
        // Different from button svg that have the background already set
        secondaryColor() {

            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/authorizedRepresentativeIcon.vue